module.exports = __webpack_public_path__ + "img/ic_invite.7ab3b09e.svg";